import React, { Component } from 'react'
import PropTypes from 'prop-types'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../../components/spacer'
import SelectItem from '../../../components/select-item'
import Slider from '../../slider'
import { jewelryTypeIsRing } from '../../../utils/jewelry-validation'

class ShankPanel extends Component {
  render () {
    const props = this.props
    const getShankTypeOptions = () => {
      let options = [
        {value: 'single_row', label: 'Single'},
        {value: 'split_rows', label: 'Split', disabled: props.jewelry_type === 'MaleWeddingBand'},
        {value: 'intertwined_rows', label: 'Intertwined', disabled: props.jewelry_type === 'MaleWeddingBand'},
        {value: 'double_rows', label: 'Double'},
        {value: 'three_rows', label: '3x'},
        {value: 'four_rows', label: '4x'},
        {value: 'five_rows', label: '5x'}
      ]

      return options
    }

    const getShankShapeOptions = () => {
      const disableTaperedShank = props =>
        props.shank_type === 'split_rows' ||
        props.shank_type === 'intertwined_rows'

      let options = [
        {value: 'straight', label: 'Straight'},
        {value: 'taper_in_towards_centre', label: 'Tapered In Toward Centre', disabled: disableTaperedShank(props)},
        {value: 'taper_out_towards_centre', label: 'Tapered Out Toward Centre', disabled: disableTaperedShank(props)}
      ]

      return options
    }

    const getVerticalShankThicknessOptions = () => {
      return [...props.verticalShankThicknessOptions, {value: 'custom', label: 'Custom'}]
    }

    const getShankStraightWidthOptions = () => {
      return [...props.defaultShankWidthOptions, {value: 'custom', label: 'Custom'}]
    }

    return (
      <JewelryPanel
        id='shankPanel'
        show={jewelryTypeIsRing(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          id='vertical_shank_thickness'
          label='Ring Weight (Vertical Shank Thickness)'
          labelId='shank'
          options={getVerticalShankThicknessOptions()}
          value={props.vertical_shank_thickness}
          onChange={props.onChangeVal.bind(this, 'vertical_shank_thickness')}
          initVal={null}
        />

        <JewelryPanel
          id='customVerticalShankThicknessPanel'
          show={props.vertical_shank_thickness === 'custom'}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <h4>Custom Shank Thickness</h4>
          <Slider
            id='custom_vertical_shank_thickness'
            single
            input
            labelRight='mm'
            min={1.3}
            max={3.0}
            step={0.1}
            value={props.custom_vertical_shank_thickness}
            onChange={props.onChangeVal.bind(this, 'custom_vertical_shank_thickness')}
            initVal={1.3}
          />
        </JewelryPanel>

        <Spacer xxs />

        <SelectItem
          label='Shank Type'
          id='shankType'
          labelId='shank_type'
          options={getShankTypeOptions()}
          value={props.shank_type}
          onChange={props.onChangeVal.bind(this, 'shank_type')}
          initVal={null}
        />

        <Spacer xxs />

        <SelectItem
          label='Shank Shape'
          id='shankShape'
          labelId='shank_shape'
          options={getShankShapeOptions()}
          value={props.shank_shape}
          onChange={props.onChangeVal.bind(this, 'shank_shape')}
          initVal={null}
        />

        <JewelryPanel
          id='shankWidthStraightPanel'
          show={props.shank_shape === 'straight'}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='shank_straight_width'
            label='Total Shank Width (Straight Shank)'
            labelId='shank_straight_width'
            options={getShankStraightWidthOptions()}
            value={props.shank_straight_width}
            onChange={props.onChangeVal.bind(this, 'shank_straight_width')}
            initVal={null}
          />

          <JewelryPanel
            id='shankWidthStraightCustomPanel'
            show={props.shank_straight_width === 'custom'}
            isResetting={props.isResetting}>

            <Spacer xxs />

            <h4>Total Shank Width (Straight Shank) - Custom</h4>
            <Slider
              id='shank_straight_custom_width'
              single
              input
              labelRight='mm'
              min={1.5}
              max={15.0}
              step={0.1}
              value={props.shank_straight_custom_width}
              onChange={props.onChangeVal.bind(this, 'shank_straight_custom_width')}
              initVal={1.5}
            />
          </JewelryPanel>
        </JewelryPanel>

        <JewelryPanel
          id='shankWidthTaperedShankPanel'
          show={(props.shank_shape === 'taper_in_towards_centre' || props.shank_shape === 'taper_out_towards_centre') &&
          !(props.shank_type === 'split_rows' || props.shank_type === 'intertwined_rows')}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <h4>Total Shank Width (Tapered Shank)</h4>
          <Slider
            id='shankWidthTaperedShank'
            sliderId='shank_tapered_width'
            double
            inputs
            min={1.0}
            max={15.0}
            step={0.1}
            minDistance={0.1}
            value={props.shank_tapered_width}
            onChange={props.onChangeVal.bind(this, 'shank_tapered_width')}
            initVal={[1, 15]}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

ShankPanel.propTypes = {
  verticalShankThicknessOptions: PropTypes.array.isRequired,
  onChangeVal: PropTypes.func.isRequired
}

export default ShankPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/shank-panel/index.js